import './InfoModal.scss';

import { Modal } from 'antd';
import { cloneElement, ReactElement, ReactNode, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface InfoModalProps {
  openButton: ReactElement;
  message: ReactNode;
  title?: string;
  onOpen?: Function;
  onClose?: Function;
}

const InfoModal = (props: InfoModalProps) => {
  const { t } = useTranslation();
  const { openButton, message, title, onOpen, onClose } = props;
  const [open, setOpen] = useState(false);
  const handleOpen = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      onOpen?.();
      setOpen(true);

      return;
    },
    [onOpen],
  );
  const handleClose = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      onClose?.();
      setOpen(false);
    },
    [onClose],
  );
  const openButtonWithOnClick = useMemo(
    () => cloneElement(openButton, { onClick: handleOpen }),
    [openButton, handleOpen],
  );

  return (
    <>
      {openButtonWithOnClick}
      <Modal
        className="InfoModal"
        open={open}
        onCancel={handleClose}
        onOk={handleClose}
        okText={t('Aceptar')}
        title={title}
        footer={(_, { OkBtn }) => (
          <>
            <OkBtn />
          </>
        )}>
        <div>{message}</div>
      </Modal>
    </>
  );
};

export default InfoModal;
